import { Box } from '@lemonade-hq/cdk';
import Image from 'next/image';
import styled from 'styled-components';

interface PartnerLogoProps {
  src: string | undefined;
  className?: string;
}

const StyledImage = styled(Image)`
  margin: 0 auto;
  pointer-events: none;
  object-fit: contain;
  user-select: none;
`;

export const PartnerLogo: React.FC<PartnerLogoProps> = ({ src, className }) => {
  if (src == null) return null;
  return (
    <Box position="relative" height={125} width="100%" mx="auto" className={className} style={{ maxWidth: 280 }}>
      <StyledImage src={src} fill alt="Partner's logo" />
    </Box>
  );
};
